<!-- Modals -->
<ui-confirmation-dialog
    header="employees.tasksIndex.deleteTask"
    primaryButtonLabel="delete"
    primaryButtonType="danger"
    secondaryButtonLabel="cancel"
    #confirmDeleteModal
>
    <p>
        {{
            'employees.tasksIndex.areYouSureYouReallyWantToDeleteTheTaskTaskToBeDeleted'
                | translate: { taskToBeDeleted: taskToBeDeleted }
        }}
    </p>
</ui-confirmation-dialog>

<app-deprecated-modal #taskDetailsModal [noBorder]="true">
    <app-task-details #taskDetails [employee]="employee" [task]="currentTask" (close)="onClose()"></app-task-details>

    <!-- Close button -->
    <div class="actions close-button flex justify-end">
        <ui-button type="ghost" (click)="onClose()">{{ 'employees.tasksIndex.close' | appTranslate }}</ui-button>
    </div>
</app-deprecated-modal>

<!-- Body -->
<div class="page-container">
    <app-header
        title="{{ 'employees.tasksIndex.people' | appTranslate }}"
        [menuService]="employeeModuleMenuService"
    ></app-header>

    <app-table [table]="tasksTable" (rowClicked)="onRowClicked($event)" (menuItemSelected)="onTableMenuEvent($event)">
        <div class="empty">
            <app-empty-state
                label="{{
                    tasksTable.hasFiltersApplied()
                        ? 'employees.tasksIndex.noTasksFoundForTheAppliedFilters'
                        : 'employees.tasksIndex.noTasksCurrentlyExistPleaseCreateAndAssignATaskTemplateInOrderTo'
                }}"
                src="/assets/illustrations/cup.png"
            >
            </app-empty-state>
            <div
                class="buttons create-task-template-button"
                *ngIf="hasManageTaskTemplatesPermission && !tasksTable.hasFiltersApplied()"
            >
                <ui-button type="primary" (click)="$event.preventDefault(); onCreateTaskTemplate()">{{
                    'employees.tasksIndex.createTaskTemplate' | translate
                }}</ui-button>
            </div>
        </div>
    </app-table>
</div>
